// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b2497edb","455":"6529e836","977":"1683703b"}[chunkId] + ".chunk.js";
};